module.exports = __webpack_public_path__ + "static/media/warning-icon.34146174.png";